import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import s from './StickyCta.module.css';

export default function StickyCta() {
  const [hidden, setHidden] = useState(false);
  useEffect(() => {
    const footer = document.querySelector('footer');
    if (!footer) return;
    const ob = new IntersectionObserver(entries => setHidden(entries[0].isIntersecting), { threshold: 0.1 });
    ob.observe(footer);
    return () => ob.disconnect();
  }, []);
  return (
    <Link to="/book-appointment" className={`${s.sticky} ${hidden ? s.hidden : ''}`}>
      <span className={s.dot}></span>
      Book Appointment
    </Link>
  );
}
